import { combineReducers } from 'redux'
import currentDirReducer from 'src/_reducers/cui/current_dir'
import cmdHistoryReducer from 'src/_reducers/cui/cmd_history'
import contentDirReducer from 'src/_reducers/cui/content_dir'
import cmdHeadReducer from 'src/_reducers/cui/cmd_head'
import mobileStatusReducer from 'src/_reducers/cui/mobile_status'
import isCmdExitReducer from 'src/_reducers/cui/is_cmd_exit'
import secretIdReducer from 'src/_reducers/cui/secret_id'
import secretCmdValueReducer from 'src/_reducers/cui/secret_cmd_value'
import secretPlayedToggleReducer from 'src/_reducers/cui/secret_played_toggle'
import secretReduxMessageReducer from 'src/_reducers/cui/secret_redux_message'
import isQuinePlayingReducer from 'src/_reducers/cui/is_quine_playing'

const Reducers = combineReducers({
  current_dir: currentDirReducer,
  cmd_history: cmdHistoryReducer,
  content_dir: contentDirReducer,
  cmd_head: cmdHeadReducer,
  mobile_status: mobileStatusReducer,
  is_cmd_exit: isCmdExitReducer,
  secret_id: secretIdReducer,
  secret_cmd_value: secretCmdValueReducer,
  secret_played_toggle: secretPlayedToggleReducer,
  is_quine_playing: isQuinePlayingReducer,
  OH_YOU_FOUND_ME: secretReduxMessageReducer,
})

export default Reducers
